import { useEffect, useRef, useState } from "react";

import ConfirmedBingoOverlay from "./ConfirmedBingoOverlay";

const LOCAL_EVENT = "ic-preview-confirmed-bingo";
const DEFAULT_NAME = "Sarah · Table 7";
const DEFAULT_STAGE_LABEL = "FULL HOUSE WINNER";
const PREVIEW_DURATION_MS = 9500;

/**
 * triggerConfirmedBingoPreview — rehearsal helper. Fires a full
 * Confirmed Bingo Celebration in the current window without touching
 * the real game.
 */
export function triggerConfirmedBingoPreview({ name, stageLabel } = {}) {
  const payload = {
    name: name || DEFAULT_NAME,
    stageLabel: stageLabel || DEFAULT_STAGE_LABEL,
    ts: Date.now(),
  };
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(LOCAL_EVENT, { detail: payload }));
  }
}

/**
 * ConfirmedBingoPreviewOverlay — global listener that renders the
 * celebration when a preview event fires. Mounted at App root.
 */
export default function ConfirmedBingoPreviewOverlay() {
  const [state, setState] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      const detail = e.detail || {};
      setState({
        name: detail.name || DEFAULT_NAME,
        stageLabel: detail.stageLabel || DEFAULT_STAGE_LABEL,
        ts: detail.ts || Date.now(),
      });
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => {
        setState(null);
        timerRef.current = null;
      }, PREVIEW_DURATION_MS);
    };
    window.addEventListener(LOCAL_EVENT, handler);
    return () => {
      window.removeEventListener(LOCAL_EVENT, handler);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <ConfirmedBingoOverlay
      active={!!state}
      name={state?.name}
      stageLabel={state?.stageLabel}
    />
  );
}
